import '../../layout/index';

function importAll(r) {
	r.keys().forEach(r);
}

importAll(require.context('../../components', true, /index\.js$/));
